import { FactoryOutlined, Group, WorkHistory } from "@mui/icons-material";
import { Avatar, Box, Typography } from "@mui/material";
import React from "react";

import TruncatedText from "../../full-time-shifts/ui/weekly-shift-view/truncated-text";
import useWorkerSchedulerData from "../controllers/use-worker-scheduler-data";
const WORKER_WIDTH = 210;

const WorkerDetailsCard: React.FC<{
	workerName: string;
	workerId: string;
	workerTypeId: string;
	workerSubTypeId: string;
  isPrinting?: boolean;
  isWorkCenterChanged?: boolean;
  isShiftPatternChanged?: boolean;
  isJobChanged?: boolean;
}> = ({ workerName, workerId, workerTypeId, workerSubTypeId, isPrinting = false, isWorkCenterChanged, isShiftPatternChanged, isJobChanged }) => {
	const { searchedTerm, filterData } = useWorkerSchedulerData();

	const workerTypeObj = filterData.workerTypesObj;
	const workerSubTypeObj = filterData.workerSubTypesObj;

	function stringAvatar(name: string) {
		if (!name)
			return {
				sx: {
					fontSize: "16px",
					color: "#e0e0e0",
					marginRight: "4px",
					height: "28px",
					width: "28px",
					marginTop: "4px",
				},
				children: "??",
			};

		const nameParts = name.trim().split(" ");
		const firstInitial = nameParts[0]?.[0] || "";
		const secondInitial = nameParts[1]?.[0] || "";

		return {
			sx: {
				fontSize: "16px",
				color: "#e0e0e0",
				marginRight: "4px",
				height: "28px",
				width: "28px",
				marginTop: "4px",
			},
			children: `${firstInitial}${secondInitial}`,
		};
	}

	return (
    <Box
      sx={{
        width: isPrinting ? "100%" : `${WORKER_WIDTH}px`,
        maxWidth: isPrinting ? "100%" : `${WORKER_WIDTH}px`,
        height: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "flex-start",
        overflow: "hidden",
        padding: isPrinting ? "4px 8px" : "8px 16px",
      }}
    >
      <Box sx={{
        display: "flex",
        alignItems: "flex-start",
        width: isPrinting ? "100%" : `${WORKER_WIDTH}px`,
        maxWidth: isPrinting ? "100%" : `${WORKER_WIDTH}px`,
        pl: 0,
      }}>
        {!isPrinting && <Avatar {...stringAvatar(workerName)} />}
        <Box sx={{
          width: isPrinting ? "100%" : `${WORKER_WIDTH - 48}px`,
          maxWidth: isPrinting ? "100%" : `${WORKER_WIDTH - 48}px`,
        }}>
          {isPrinting &&
            <Box sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              width: "100%",
            }}>
              <Box sx={{
                width: "40%"
              }} />
              <Box sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "20%",
                gap: "4px",
                pl: 1,
              }}>
                <TruncatedText text={workerId}
                               tooltipDisabled={false}
                               searchedTerm={searchedTerm}
                               disablePortal={false}
                               style={{
                                 color: "rgba(0, 0, 0, 0.87)",
                                 fontFamily: "Roboto",
                                 fontSize: "12px",
                                 fontStyle: "normal",
                                 fontWeight: 400,
                                 lineHeight: "16px",
                                 letterSpacing: "0.4px",
                                 overflow: "visible",
                                 textOverflow: "auto",
                                 whiteSpace: "wrap",
                                 wordBreak: "break-word",
                                 maxWidth: `${WORKER_WIDTH - 32}px`,
                               }}
                />
                {isWorkCenterChanged && isPrinting && <FactoryOutlined sx={{
                  color: "rgba(0, 0, 0, 0.60)",
                  fontSize: "12px",
                }} />}
                {isShiftPatternChanged && isPrinting && <Group sx={{
                  color: "#000000DE",
                  fontSize: "12px",
                }} />}
                {isJobChanged && isPrinting && <WorkHistory sx={{
                  color: "#000000DE",
                  fontSize: "12px",
                }} />}
              </Box>
              <Box sx={{
                width: "40%",
              }}>
                <TruncatedText
                  text={workerName}
                  searchedTerm={searchedTerm}
                  tooltipDisabled={false}
                  disablePortal={false}
                  style={{
                    color: "rgba(0,0,0,1)",
                    fontFamily: "Roboto",
                    fontSize: isPrinting ? "12px" : "14px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: isPrinting ? "14px" : "20px",
                    letterSpacing: "0.1px",
                    overflow: isPrinting ? "visible" : "hidden",
                    textOverflow: isPrinting ? "auto" : "ellipsis",
                    whiteSpace: isPrinting ? "wrap" : "nowrap",
                    wordBreak: isPrinting ? "break-word" : "normal",
                    width: isPrinting ? "100%" : `${WORKER_WIDTH - 48}px`,
                    maxWidth: isPrinting ? "100%" : `${WORKER_WIDTH - 48}px`,
                    pl: 1,
                  }}
                />
              </Box>
            </Box>
          }
          {!isPrinting &&
            <TruncatedText
              text={workerName}
              searchedTerm={searchedTerm}
              tooltipDisabled={false}
              disablePortal={false}
              style={{
                color: "rgba(0,0,0,1)",
                fontFamily: "Roboto",
                fontSize: isPrinting ? "11px" : "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: isPrinting ? "14px" : "20px",
                letterSpacing: "0.1px",
                overflow: isPrinting ? "visible" : "hidden",
                textOverflow: isPrinting ? "auto" : "ellipsis",
                whiteSpace: isPrinting ? "wrap" : "nowrap",
                wordBreak: isPrinting ? "break-word" : "normal",
                width: isPrinting ? `${WORKER_WIDTH - 32}px` : `${WORKER_WIDTH - 48}px`,
                maxWidth: isPrinting ? `${WORKER_WIDTH - 32}px` : `${WORKER_WIDTH - 48}px`,
                pl: isPrinting ? 3 : 0,
              }}
            />
          }
          {!isPrinting &&
            <TruncatedText text={
              workerTypeObj?.[workerTypeId]?.name +
              " " +
              (workerSubTypeObj?.[workerSubTypeId]?.name
                ? `(${workerSubTypeObj?.[workerSubTypeId]?.name})`
                : "")
            } tooltipDisabled={false}
                           disablePortal={false}
                           searchedTerm={searchedTerm}
                           style={{
                             color: "rgba(0, 0, 0, 0.87)",
                             fontFamily: "Roboto",
                             fontSize: isPrinting ? "11px" : "14px",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: isPrinting ? "14px" : "20px",
                             letterSpacing: "0.17px",
                             overflow: isPrinting ? "visible" : "hidden",
                             textOverflow: isPrinting ? "auto" : "ellipsis",
                             whiteSpace: isPrinting ? "wrap" : "nowrap",
                             wordBreak: isPrinting ? "break-word" : "normal",
                             width: isPrinting ? `${WORKER_WIDTH - 32}px` : `${WORKER_WIDTH - 48}px`,
                             maxWidth: isPrinting ? `${WORKER_WIDTH - 32}px` : `${WORKER_WIDTH - 48}px`,
                             pl: isPrinting ? 3 : 0,
                           }}
            />
          }
          {!isPrinting &&
            <TruncatedText text={workerId}
                           tooltipDisabled={false}
                           searchedTerm={searchedTerm}
                           disablePortal={false}
                           style={{
                             color: "rgba(0, 0, 0, 0.60)",
                             fontFamily: "Roboto",
                             fontSize: isPrinting ? "10px" : "12px",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: isPrinting ? "14px" : "20px",
                             letterSpacing: "0.4px",
                             overflow: isPrinting ? "visible" : "hidden",
                             textOverflow: isPrinting ? "auto" : "ellipsis",
                             whiteSpace: isPrinting ? "wrap" : "nowrap",
                             wordBreak: isPrinting ? "break-word" : "normal",
                             width: isPrinting ? `${WORKER_WIDTH - 16}px` : `${WORKER_WIDTH - 48}px`,
                             maxWidth: isPrinting ? `${WORKER_WIDTH - 16}px` : `${WORKER_WIDTH - 48}px`,
                           }}
            />
          }
        </Box>
      </Box>
    </Box>
  );
};

export default WorkerDetailsCard;
